var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIClear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Canvas",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "remove users"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    strokeWidth: 2,
    stroke: "#828282"
  })), /*#__PURE__*/React.createElement("g", {
    id: "close"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path 2",
    transform: "translate(6.50006 6.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M 5 0L 0 5Z",
    fill: "#828282"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 5 0L 0 5",
    strokeWidth: 2,
    stroke: "#828282"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path 2 Copy",
    transform: "translate(11.5001 6.5) scale(-1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M 5 0L 0 5Z",
    fill: "#828282"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 5 0L 0 5",
    strokeWidth: 2,
    stroke: "#828282"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIClear);
export default __webpack_public_path__ + "static/media/i_clear.cd41e47abc915e1fd255b94ef993bbf3.svg";
export { ForwardRef as ReactComponent };